import React, { memo } from "react";
import { NavLink } from "react-router-dom";
import { Col, Collapse, Row } from "reactstrap";

interface Props {
  readonly menuItems: any[] | null;
}

// Import Data
export default memo(function HorizontalLayout({ menuItems }: Props) {
  return (
    <React.Fragment>
      {menuItems?.map((item, key) => {
        return (
          <React.Fragment key={key}>
            {!item["isHeader"] ? (
              item.subItems ? (
                <li className="nav-item" style={{ marginLeft: "5px" }}>
                  <NavLink
                    onClick={item.click}
                    className={`nav-link menu-link ${"" && "active"}`}
                    to={item.link}
                    data-bs-toggle="collapse"
                  >
                    <i className={item.icon} /> <span data-key="t-apps">{item.label}</span>
                  </NavLink>
                  <Collapse
                    className={
                      item.subItems.length > 11
                        ? "menu-dropdown mega-dropdown-menu"
                        : "menu-dropdown"
                    }
                    isOpen={item.stateVariables}
                    id="sidebarApps"
                  >
                    {/* subItms  */}
                    {item.subItems.length > 11 ? (
                      <React.Fragment>
                        <Row>
                          {item.subItems &&
                            (item.subItems || []).map((subItem: any, key: any) => (
                              <React.Fragment key={subItem.id}>
                                {key % 2 === 0 ? (
                                  <Col lg={4}>
                                    <ul className="nav nav-sm flex-column">
                                      <li className="nav-item">
                                        <NavLink to={item.subItems[key].link} className="nav-link">
                                          {item.subItems[key].label}
                                        </NavLink>
                                      </li>
                                    </ul>
                                  </Col>
                                ) : (
                                  <Col lg={4}>
                                    <ul className="nav nav-sm flex-column">
                                      <li className="nav-item">
                                        <NavLink to={item.subItems[key].link} className="nav-link">
                                          {item.subItems[key].label}
                                        </NavLink>
                                      </li>
                                    </ul>
                                  </Col>
                                )}
                              </React.Fragment>
                            ))}
                        </Row>
                      </React.Fragment>
                    ) : (
                      <ul className="nav nav-sm flex-column test">
                        {item.subItems &&
                          item.subItems.map((subItem: any) => (
                            <React.Fragment key={subItem.id}>
                              {
                                <li className="nav-item">
                                  <NavLink
                                    className="nav-link"
                                    to={subItem.link}
                                    data-bs-toggle="collapse"
                                  >
                                    {subItem.label}
                                  </NavLink>
                                </li>
                              }
                            </React.Fragment>
                          ))}
                      </ul>
                    )}
                  </Collapse>
                </li>
              ) : (
                <li className="nav-item">
                  <NavLink className="nav-link menu-link" to={item.link}>
                    <i className={item.icon} /> <span>{item.label}</span>
                  </NavLink>
                </li>
              )
            ) : (
              <li className="menu-title">
                <span data-key="t-menu">{item.label}</span>
              </li>
            )}
          </React.Fragment>
        );
      })}
      {/* menu Items */}
    </React.Fragment>
  );
});
